<template>
<div>
    <v-card class="display-block" flat>
        <h3>Modify Customer</h3>
        <v-card-text>
            <alert-message v-if="msg" :error="msg"></alert-message>
            <v-form ref="form" lazy-validation>
                <v-row>
                    <v-flex>
                        <v-text-field label="FirstName*" class="mx-3" :rules="firstNameRules" v-model="customer.firstName" required></v-text-field>
                    </v-flex>
                    <v-flex>
                        <v-text-field label="MiddleName" class="mx-3" v-model="customer.middleName"></v-text-field>
                    </v-flex>
                    <v-flex>
                        <v-text-field label="LastName*" class="mx-3" :rules="lastNameRules" v-model="customer.lastName" required></v-text-field>
                    </v-flex>
                </v-row>
                <v-flex>
                    <v-text-field label="Mobile No*" :rules="mobileNoRules" v-model="customer.mobileNo" required></v-text-field>
                </v-flex>
                <v-flex>
                    <v-text-field :filled="!editEmail" :readonly="!editEmail" label="E-Mail" :rules="emailRules" v-model="customer.email"></v-text-field>
                </v-flex>
                <v-flex>
                    <v-autocomplete v-model="customer.roles" :items="rolesArray" label="Roles" item-text="name" item-value="_id" multiple return-object />
                </v-flex>
                <alert-message v-if="msg" :error="msg"></alert-message>
                <v-flex text-right>
                    <v-btn class="mr-4" :style="theme" @click="submit()">Save</v-btn>
                    <v-btn class="mr-4" :style="themeInverted" outlined @click="$router.go(-1)">Cancel</v-btn>
                </v-flex>
            </v-form>
        </v-card-text>
    </v-card>
</div>
</template>

<script>
import appConstants from '@/utils/appConstants'
import axios from 'axios'
export default {
    data() {
        return {
            customer: {
                firstName: "",
                middleName: "",
                lastName: "",
                mobileNo: "",
                email: "",
                roles: [],
                userType: 'CUSTOMER'
            },
            editEmail: true,
            items: [],
            rolesArray: []
        }
    },
    mounted() {
        this.initComponent();
    },
    methods: {
        async initComponent() {
            this.id = this.$route.params.id
            this.customer.vendorId = this.getUserProfile().vendorId
            let roleData= await this.getItem(appConstants.ROLES_API)
            this.rolesArray =roleData.data
            if (this.id != 0) {
                this.customer = await this.getItem(appConstants.CUSTOMERS_API + "/" + this.id)
                if (this.customer.login == 'GOOGLE')
                    this.editEmail = false
            }
        },
        submit() {
            if (this.$refs.form.validate()) {
                if (this.id == 0) {
                    this.saveItem()
                } else {
                    this.updateItem()
                }
            }
        },
        async saveItem() {
            try {
                this.customer = await this.postItem(appConstants.CUSTOMERS_API, this.customer)
                this.$router.push({ name: "Customers" })
            } catch (error) {
                this.handleError(error)
                this.msg = error.response.data
            }
        },
        async updateItem() {
            try {
                await this.putItem(appConstants.CUSTOMERS_API + "/" + this.customer._id, this.customer)
                this.$router.push({ name: "Customers" })
            } catch (error) {
                this.handleError(error)
                this.msg = error.response.data
            }
        }
    },
}
</script>
